import { render, staticRenderFns } from "./tasima.vue?vue&type=template&id=c1a560b2&"
import script from "./tasima.vue?vue&type=script&lang=js&"
export * from "./tasima.vue?vue&type=script&lang=js&"
import style0 from "./tasima.vue?vue&type=style&index=0&id=c1a560b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports